<template>
    <el-card class="card-funnel blue-widget pb-2">
        <div v-if="$slots.header" slot="header">
            <slot name="header"></slot>
        </div>
        <slot></slot>
        <div class="dashboard-funnel-container w-100" ref="funnelContainer">
            <div class="row pt-4" v-if="width && hasValue">
                <vue-funnel-graph
                    ref="funnelGraph"
                    :width="width"
                    :height="height"
                    :labels="labels"
                    :values="values"
                    :colors="colors"
                    :sub-labels="subLabels"
                    :direction="direction"
                    :gradient-direction="gradientDirection"
                    :animated="true"
                    :display-percentage="true"
                ></vue-funnel-graph>
            </div>
            <div class="row col-12 mt-2" v-else>
            <span class="text-muted small">No results available</span>
            </div>
        </div>
  </el-card>
</template>

<script>
import { VueFunnelGraph } from 'vue-funnel-graph-js';
export default {
  components: {
    VueFunnelGraph
  },
  props: {
    token: {
      type: String,
      required: true
    },
    dateScope: {
      type: Object,
      required: true
    },
    teamId: {
      type: [Number, String],
      required: false
    },
    brokerId: {
      type: Number,
      required: false
    },
    allowDataView: {
      type: [Boolean,Number,String],
      required: false,
      default: false
    }
  },
  data() {
    return {
      pipelineData: [],
      labels: ['New', 'Apps', 'Approvals', 'Options', 'Settled'],
      subLabels: [],
      values: [],
      colors: [
        ['#7b4397', '#dc2430'],
        ['#ff5f6d', '#ffc371'],
        ['#185a9d', '#43cea2'],
        ['#FFB178', '#FF3C8E'],
        ['#A0BBFF', '#EC77FF'],
        ['#A0F9FF', '#7795FF'],
        ['#F4E2D8', '#BA5370'],
        ['#43cea2', '#185a9d'],
      ],
      direction: 'horizontal',
      gradientDirection: 'horizontal',
      height: 300,
      width: 0
    }
  },
  watch: {
    dateScope: {
      handler(newVal, oldVal) {
        this.refreshData();
      },
      deep: true
    },
    teamId: {
      handler(newVal, oldVal) {
        this.refreshData();
      },
      deep: true
    },
    brokerId: {
      handler(newVal, oldVal) {
        this.refreshData();
      },
      deep: true
    }
  },
  computed: {
    hasValue() {
      return !!this.values.find(col => col.length > 0);
    }
  },
  mounted() {

    this.refreshData();

    if (this.allowDataView) {

      $('.dashboard-funnel-container').on('mouseover', '.svg-funnel-js .svg-funnel-js__label', function(e) {
        $(this).addClass('column-stat-hover');
      }).on('mouseout', '.svg-funnel-js .svg-funnel-js__label', function(e) {
        $(this).removeClass('column-stat-hover');
      });

      $('.dashboard-funnel-container').on('click', '.svg-funnel-js .svg-funnel-js__label', function(e) {
        let startDate = this.$moment(this.dateScope.startDate).format('YYYY-MM-DD');
        let endDate = this.$moment(this.dateScope.endDate).format('YYYY-MM-DD');
        let stageColumn = $(e.currentTarget).index();
        let stageNumber;
        switch (stageColumn) {
          case 0:
            stageNumber = 0;
            break;
          case 1:
            stageNumber = 2;
            break;
          case 2:
            stageNumber = 5;
            break;
          case 3:
            stageNumber = 8;
            break;
          case 4:
            stageNumber = 14;
            break;
          default:
            break;
        }
        let url = '/admin/v2/application-search?start_date=' + startDate + '&end_date=' + endDate + '&ref=dashboard-activity&pagination_limit=100';

        if (stageNumber == 0) {
          url = url + '&status%5B%5D=0';
        } else {
          url = url + '&stage%5B%5D=' + stageNumber;
        }

        if (this.teamId) {
           url = url + '&team%5B%5D=' + this.teamId;
        }
        window.open(url, 'adv_search');
      }.bind(this));

    }

  },
  created() {
    window.addEventListener("resize", this.resizeEventHandler);
    this.$bus.$on("refreshed-data", value => {
      this.refreshData();
    });
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeEventHandler);
  },
  methods: {
    resizeEventHandler() {
        if (this.hasValue && this.$refs.funnelContainer && this.$refs.funnelContainer.clientWidth) {
            this.width = this.$refs.funnelContainer.parentElement.clientWidth + 3;
            this.funnelRefresh(this.$refs.funnelGraph);
        }
    },
    refreshData() {
      this.getMonthlyPipeline();
    },
    funnelRefresh: _.debounce((funnel) => {
        if (funnel && typeof funnel['$mount'] !== 'undefined') {
            funnel.$mount();
        }
    }, 300),
    async getMonthlyPipeline() {
      try {
        let res = await axios.get(`/api/v2/pipeline`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          },
          params: {
            startDate: this.$moment(this.dateScope.startDate).format('YYYY-MM-DD'),
            endDate: this.$moment(this.dateScope.endDate).format('YYYY-MM-DD'),
						teamId: this.teamId,
            brokerId: this.brokerId
          }
        });

        this.pipelineData = res.data;

        this.values = Object.values(this.pipelineData.values);
        this.subLabels = Object.values(this.pipelineData.subLabels);

        this.resizeEventHandler();

      } catch (err) {
        console.error(err);
      }
    }
  }
}
</script>

<style lang="scss">

.el-card.card-funnel {
    overflow: visible;
}

.svg-funnel-js .column-stat-hover {
    cursor: help;
    font-weight: 600;
}

.svg-funnel-js .svg-funnel-js__labels .svg-funnel-js__label .label__segment-percentages {
    width: auto;
    white-space: nowrap;
    z-index: 99999999999999999;
}

.svg-funnel-js {
    font-family: "Poppins", serif;

	.svg-funnel-js__labels {

    height: calc(100% - 45px);

		.svg-funnel-js__label {

			.label__value {
				color: #284da5;
			}

			.label__title {
				color: #555555;
			}

			.label__percentage {
				color: #2493ee;
      }

      .label__segment-percentages {
          padding: 0px 14px;
          width: auto;
          white-space: nowrap;
          z-index: 1019;
      }

		}

  }

	&:not(.svg-funnel-js--vertical) {

		.svg-funnel-js__label {

			&:not(:first-child) {
				border-left: 1px solid #5555557e;
			}
		}
	}

	&.svg-funnel-js--vertical {

		.svg-funnel-js__label {

			&:not(:first-child) {
				border-top: 1px solid #5555557e;
			}
		}
    }

	.svg-funnel-js__subLabels {

    background: transparent;

		.svg-funnel-js__subLabel {
			color: #555555;
        }

        .svg-funnel-js__subLabel--title {
            white-space: nowrap;
        }
	}

}
</style>
